import { render, staticRenderFns } from "./AddGame.vue?vue&type=template&id=6093722a&scoped=true&"
import script from "./AddGame.vue?vue&type=script&lang=js&"
export * from "./AddGame.vue?vue&type=script&lang=js&"
import style0 from "./AddGame.vue?vue&type=style&index=0&id=6093722a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093722a",
  null
  
)

export default component.exports